<div class="menu">
  <div class="logo">
    <div class="first"></div>
    <div class="second">
      <i class="pi pi-box"></i>
    </div>
    <div class="third"></div>
  </div>
</div>
<div class="login">
  <h1>{{ environment.softwareName }}</h1>
  <small class="block text-center">v{{ environment.version }}</small>
  <p-messages
    [(value)]="msgs"
    [enableService]="false"></p-messages>

  <!-- Passo 1: credenziali -->
  <form
    *ngIf="step === 'credentials'"
    [formGroup]="frm"
    (ngSubmit)="login()"
    class="w-full">
    <div class="flex flex-column gap-2 justify-content-center align-items-stretch">
      <div>
        <span class="p-float-label">
          <input
            pInputText
            id="username"
            formControlName="username" />
          <label htmlFor="username">Username</label>
        </span>
        <app-form-errors
          *ngIf="frm.get('username')?.errors && frm.get('username')?.dirty"
          [errors]="frm.get('username')?.errors"></app-form-errors>
      </div>
      <div>
        <span class="p-float-label">
          <p-password
            inputId="password"
            formControlName="password"
            autocomplete="current-password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="w-full"
            [inputStyle]="{ width: '100%' }"></p-password>
          <label htmlFor="password">Password</label>
        </span>
        <app-form-errors
          *ngIf="frm.get('password')?.errors && frm.get('password')?.dirty"
          [errors]="frm.get('password')?.errors"></app-form-errors>
      </div>
      <div class="mx-auto w-3">
        <p-button
          styleClass="butt w-full"
          type="submit"
          [disabled]="frm.invalid"
          [loading]="loading"
          label="Accedi"
          [rounded]="true" />
      </div>
      <div class="mx-auto">
        <a routerLink="/password-dimenticata">Password dimenticata?</a>
      </div>
    </div>
  </form>

  <!-- Passo 2 (solo alla prima volta): configurazione dell'app autenticatore -->
  <div
    *ngIf="step === 'enroll'"
    class="mfa-enroll w-full">
    <h3 class="text-center m-0">Configura la verifica in due passaggi</h3>
    <p class="text-center">
      Per proteggere il tuo account serve un'app autenticatore sul telefono, ad esempio Google
      Authenticator, Microsoft Authenticator o Authy.
    </p>
    <ol class="pl-3">
      <li>Apri l'app e scegli di aggiungere un nuovo account.</li>
      <li>Inquadra il codice QR qui sotto, oppure inserisci a mano la chiave.</li>
      <li>Scrivi qui sotto il codice a 6 cifre che l'app ti mostra.</li>
    </ol>
    <div class="flex flex-column align-items-center gap-2">
      <img
        *ngIf="qrDataUrl"
        class="qr"
        [src]="qrDataUrl"
        alt="Codice QR da inquadrare con l'app autenticatore" />
      <div class="flex align-items-center gap-2">
        <code class="secret">{{ formattedSecret }}</code>
        <p-button
          type="button"
          styleClass="butt"
          [rounded]="true"
          [icon]="secretCopied ? 'pi pi-check' : 'pi pi-copy'"
          pTooltip="Copia la chiave"
          tooltipPosition="bottom"
          (click)="copySecret()"></p-button>
      </div>
    </div>
  </div>

  <!-- Passo 2/3: codice -->
  <form
    *ngIf="step === 'code' || step === 'enroll'"
    [formGroup]="mfaFrm"
    (ngSubmit)="verifyCode()"
    class="w-full">
    <div class="flex flex-column gap-2 justify-content-center align-items-stretch">
      <p
        *ngIf="step === 'code'"
        class="text-center m-0">
        Inserisci il codice a 6 cifre mostrato dalla tua app autenticatore.
      </p>
      <div>
        <span class="p-float-label">
          <input
            #codeInput
            pInputText
            id="code"
            formControlName="code"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="7" />
          <label htmlFor="code">Codice di verifica</label>
        </span>
      </div>
      <div class="flex align-items-center gap-2">
        <p-checkbox
          formControlName="remember"
          [binary]="true"
          inputId="remember"></p-checkbox>
        <label
          for="remember"
          class="mb-0"
          >Ricorda questo dispositivo: ai prossimi accessi non verrà richiesto il codice</label
        >
      </div>
      <div class="mx-auto w-3">
        <p-button
          styleClass="butt w-full"
          type="submit"
          [disabled]="mfaFrm.invalid"
          [loading]="loading"
          [label]="step === 'enroll' ? 'Conferma' : 'Verifica'"
          [rounded]="true" />
      </div>
      <div class="mx-auto">
        <a
          class="cursor-pointer"
          (click)="backToCredentials()"
          >Torna al login</a
        >
      </div>
    </div>
  </form>
</div>
